import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import * as QuoteActions from './mini-quote-cart.actions';
import { QuoteCartService } from '../../../quote/quote-services/quote-cart.service';

@Injectable()
export class QuoteCartEffects {
  constructor(
    private actions$: Actions,
    private quoteCartService: QuoteCartService
  ) {}

  fetchCartData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(QuoteActions.loadQuoteCart),
      switchMap(() => {
        const isLoggedIn = !!sessionStorage.getItem('cartId-current');
        const cartId = isLoggedIn ? sessionStorage.getItem('cartId-current') : sessionStorage.getItem('cartId-anonymous');
        
        return this.quoteCartService.getCart(cartId, 'current').pipe(
          map(apiResponse => QuoteActions.loadQuoteCartSuccess({ data: apiResponse })),
          catchError(error => of(QuoteActions.loadQuoteCartFail({ error })))
        );
      })
    )
  );
}